type CollectStatusFilterSkeletonProps = {
  /** Number of tab placeholders — pass the real filter's option count. */
  count: number;
};

/**
 * Placeholder for the status filter tabs while the student counts load. Mirrors
 * CollectStatusFilter's container so the header doesn't shift on load.
 */
export const CollectStatusFilterSkeleton = ({
  count
}: CollectStatusFilterSkeletonProps) => (
  <div className="inline-flex items-center gap-1 rounded-xl bg-interface-neutral-2 p-1">
    {Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className="h-10 w-24 animate-pulse rounded-lg bg-interface-neutral-3"
      />
    ))}
  </div>
);
